import { FGAvatar, FGStack, FGStackItem, FGTypography } from '@fg/design-system';
import { getLogoUrl } from '../services/logoHelper';

type Props = {
  logoType: string;
};


const LogoImage = ({ src, width, height }: { src: string; width: string; height?: string }) => (
  <img src={src} alt="Header Logo" width={width} height={height} />
);

type LogoTextProps = {
  logoUrl: string;
  text: string;
};

const LogoWithText = ({ logoUrl, text }: LogoTextProps) => (
  <FGStack direction="row" alignItems="center">
    <FGStackItem>
      <FGAvatar isSquare isBordered>
        <LogoImage src={logoUrl} width="32" height="32" />
      </FGAvatar>
    </FGStackItem>
    <FGStackItem>
      <FGTypography tag="span" style="headline6" color="strong">
        {text}
      </FGTypography>
    </FGStackItem>
  </FGStack>
);

export const HeaderLogo = ({ logoType }: Props) => {
  const currentLocation = window.location.host;
  
  const isSimpleLogo = logoType === 'pro' || logoType === 'sustainable' || logoType == 'credit-sights' || logoType == 'geoquant';

  const isAdminLogo = logoType === 'admin'

  const LOGO_MAPPINGS = {
    'admin': 'App_brandmarks_AccessPlus.jpg',
    'pro': 'App_brandmarks_FRProHeader.svg',
    'sustainable': 'App_brandmarks_SustainableFitch.svg',
    'credit-sights': 'App_brandmarks_CreditSights.svg',
    'geoquant': 'App_brandmarks_Geoquant_logo.svg',
    default: 'App_brandmarks_Fitch_Solutions_1.svg'
  } as const;
  
  const logoUrl = getLogoUrl(
    LOGO_MAPPINGS[logoType as keyof typeof LOGO_MAPPINGS] || LOGO_MAPPINGS.default,
    currentLocation
  );

  if (isSimpleLogo) {
    return <LogoImage src={logoUrl} width="200" />;
  }

  if (isAdminLogo) {
    return <LogoWithText logoUrl={logoUrl} text="Access+" />;
  }
  

  return <LogoWithText logoUrl={logoUrl} text="FitchSolutions" />;
};
